<template>
  <header-base>
    <template v-slot:rightPc>
      <v-button-Main
        :is-external-link="true"
        external-url="https://www.youtube.com/channel/UCXLqL61psWQGGspwXo_7sFQ"
        icono="mdiSoccer"
        :link="{name: 'login'}"
        action="¿Que es DS?"
        bg=""
        color="#dfe6e9"
      />
      <v-button-Main
        v-if="!isLoggedIn"
        icono="mdiStore"
        :link="{name: 'login'}"
        action="Tienda"
        bg="#f39c12"
        color=" #dfe6e9"
      />
      <v-button-Main
        v-else
        icono="mdiStore"
        action="Tienda"
        :link="{name: 'tienda'}"
        bg="#f39c12"
        color=" #dfe6e9"
      />

      <v-button-main
        v-if="!isLoggedIn"
        icono="mdiLoginVariant"
        :link="{name: 'login'}"
        action="Ingresar"
        bg="#2980b9"
        color="#dfe6e9"
      />
      <v-button-main
        v-else
        icono="mdiLoginVariant"
        :link="{name: 'home'}"
        action="Ir a Home"
        bg="#2980b9"
        color="#dfe6e9"
      />
    </template>

    <template v-slot:rightMov>
      <div class="no-user">
        <a href="/" class="no-user__logo">Deporstar</a>
        <router-link
          :to="{name: 'login'}"
          class="no-user__login">
          <icono
            icon="mdiLoginVariant" 
            :size="25"
            :style="{color: '#2d3436'}"></icono>
          <span class="no-user__login__text">Ingresar</span>
        </router-link>
      </div>
    </template>
  </header-base>
</template>
<script>
  //
  import VButtonMain from '@/components/base/VButtonMain.vue'
  import HeaderBase from './HeaderBase.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'HeaderMain',
    components: {
      VButtonMain,
      HeaderBase
    },
    computed: {
      ...mapGetters({
        isLoggedIn: 'isLoggedIn'
      })
    },
  }
</script>

<style lang="scss" scoped>
  .no-user {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: $ff-1;
    &__logo {
      text-decoration: none;
      color: $color-white;
      font-weight: bold;
    }
    &__login {
      text-decoration: none;
      display: flex;
      align-items: center;
      background: $color-5;
      padding: 2px 10px;
      border-radius: 5px;
      color: $color-1;
      &__text {
        margin-left: 10px;
        font-weight: bold;
        margin-bottom: 3px;
      }
    }
  }
  .icono-reigth {
    text-decoration: none;
  }
</style>